// fire custom event to window so other components can listen to it ie lander tracking

export const setLocalStorageWithEvent = (key: string, value: string) => {
    localStorage.setItem(key, value);
    window.dispatchEvent(
      new CustomEvent("local-storage", {
        detail: { key, value },
      })
    );
  };
  